import { Immutable } from "immer";
import React from "react";

import type { ProductHeroBanner as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { originalUrl } from "../../utils/wagtail";

import panelStyles from "../../styles/composable/panel.module.scss";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/hero_banners/product_hero_banner.html`` (#33285).
 */
export const ProductHeroBanner = (props: IProps): React.JSX.Element => {
    const value = props.value;
    return (
        <section
            className={concatClassNames([
                panelStyles.panel,
                panelStyles.panelOffset,
            ])}
            style={{
                backgroundImage: `url('${originalUrl(value.image)}')`,
            }}
        >
            <div className={panelStyles.panelContent}>
                {value.title && (
                    <h2 className={panelStyles.panelLine}>{value.title}</h2>
                )}
                <h1 className={panelStyles.panelTitle}>{value.subtitle}</h1>
                <p
                    className={concatClassNames([
                        panelStyles.panelCopy,
                        "alt-copy",
                    ])}
                >
                    {value.description}
                </p>
            </div>
        </section>
    );
};
